import Loader from "components/shared/Loader";
import SaveChangesButton from "components/shared/SaveChangesButton";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { editSection, getSection } from "store/actions";

const UpdateHeading = () => {
  const { loading, error, section } = useSelector((state) => state.section);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,

    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  useEffect(() => {
    dispatch(getSection({ page: "home", slug: "worksHeading" }));
  }, [dispatch]);
  useEffect(() => {
    if (section) {
      reset({
        heading: {
          ar: section?.data?.heading?.ar,
          en: section?.data?.heading?.en,
        },
        subHeading: {
          ar: section?.data?.subHeading?.ar,
          en: section?.data?.subHeading?.en,
        },
      });
    }
    return () => reset({});
  }, [reset, section]);
  const onSubmit = (data) => {
    data.title = data?.heading?.en;
    dispatch(editSection({ page: "home", slug: "worksHeading", data: { section: data }, toast }));
  };
  if (loading) {
    return <div className="card"><Loader /></div>
  }
  return (
    <>
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id="ourWorksHeading" />
          </h4>
        </div>
        <div className="card-body form-group settings-tabs">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    {" "}
                    <FormattedMessage id={"heading"} /> ({" "}
                    <FormattedMessage id={"arabic-language"} /> )
                  </h5>
                  <input
                    type="text"
                    {...register("heading.ar", { required: true })}
                    className="form-control form-outline"
                    defaultValue={section?.heading?.ar}
                  />
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    {" "}
                    <FormattedMessage id={"heading"} /> ({" "}
                    <FormattedMessage id={"english-language"} /> )
                  </h5>
                  <input
                    type="text"
                    {...register("heading.en", { required: true })}
                    className="form-control form-outline"
                    defaultValue={section?.heading?.en}
                  />
                </div>
              </Col>
            </Row>

            {/* subHeading  */}
            <Row>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    {" "}
                    <FormattedMessage id={"subHeading"} /> ({" "}
                    <FormattedMessage id={"arabic-language"} /> )
                  </h5>
                  <input
                    type="text"
                    {...register("subHeading.ar", { required: true })}
                    className="form-control form-outline"
                    defaultValue={section?.subHeading?.ar}
                  />
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    {" "}
                    <FormattedMessage id={"subHeading"} /> ({" "}
                    <FormattedMessage id={"english-language"} /> )
                  </h5>
                  <input
                    type="text"
                    {...register("subHeading.en", { required: true })}
                    className="form-control form-outline"
                    defaultValue={section?.subHeading?.en}
                  />
                </div>
              </Col>
            </Row>
            <Col lg={12}>
              <SaveChangesButton addNew={false} isLoading={loading} />
            </Col>
          </form>
        </div>
      </div>
    </>
  );
};

export default UpdateHeading;
